import React from "react";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Icon } from "@iconify/react/dist/iconify.js";
import Title from "./ui/Title";
import { useCollections } from "@/context/Collections";
import { useExpedition } from "@/context/Expeditions";
import ExpertList from "./website/footer/expert";

const CompanyLinks = [
  { name: "About us", href: "/about_us" },
  { name: "Our team", href: "/our_team" },
  { name: "Message from Founder", href: "/message_from_ceo" },
  { name: "Certificates", href: "/certificates" },
  { name: "Become Partner with us", href: "/partner" },
  { name: "Terms & Conditions", href: "/terms" },
];

const associate = [
  {
    img: "/logo/associated1.png",
    title: "Ministry of culture Tourism and Civil Aviation",
  },
  {
    img: "/logo/nmalogo.png",
    title: "Nepal Mountaineering Association",
  },
];

const partners = [
  {
    img: "/partners/partner1.png",
    link: "https://www.outdoorsolution.com.sg",
  },
  {
    img: "/partners/partner2.jpg",
    link: "https://www.valmalencoalpina.com/",
  },
  {
    img: "/partners/partner3.png",
    link: "https://www.camp.it/",
  },
  {
    img: "/partners/outdoor.jpg",
    link: "https://www.outdoorsolution.com.sg",
  },
  {
    img: "/partners/rescue.jpg",
    link: "https://partner.globalrescue.com/infinityadventurenepal/index.html",
  },

  // {
  //   img: "/partners/client12 (1).png",
  // },
];

const settings = {
  dots: false,
  arrows: false,
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  speed: 3000,
  autoplaySpeed: 30,
  cssEase: "linear",
  rtl: false, // Add this line to change the slide direction
  pauseOnHover: false, // Continue sliding when hovered
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        pauseOnHover: false, // Continue sliding when hovered
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
        infinite: true,
        pauseOnHover: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        pauseOnHover: false,
      },
    },
  ],
};

interface Package {
  packageName: string;
  packageImg: StaticImageData;
  packageDesc: string;
  packageDay: string;
}

export default function Footer() {
  const { expeditions } = useExpedition();
  const { collections } = useCollections();

  const currentYear = new Date().getFullYear();
  return (
    <div className="w-full bg-[#1E1E1E] overflow-x-hidden relative overflow-hidden">
      <div className="h-full mx-auto py-9">
        {/* meet our experts */}
        <div className="text-white">
          <Title
            text="Meet Our Experts"
            fontSize="!text-2xl"
            textalign="text-center"
            color="text-white"
          />
          <ExpertList />
        </div>

        <div className="w-11/12 4xl:w-10/12 mx-auto text-white my-6">
          <Title
            text="Our Partners"
            fontSize="!text-2xl"
            textalign="text-center"
            color="text-white"
          />

          <div className="my-8 hidden md:grid md:grid-cols-5 gap-6 items-center w-full">
            {partners.map((item, index) => (
              <Link
                href={item.link}
                key={index}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full"
              >
                <figure
                  className="bg-white p-4 w-full h-20 flex items-center justify-center rounded-md hover:opacity-90 transition-opacity shadow-sm"
                >
                  <Image
                    src={item.img}
                    alt="partner-image"
                    width={500}
                    height={200}
                    className="max-h-12 w-auto max-w-[85%] object-contain object-center"
                  />
                </figure>
              </Link>
            ))}
          </div>

          <div className="my-8 md:hidden block w-full">
            <Slider {...settings} className="my-8">
              {partners.map((item, index) => (
                <Link
                  href={item.link}
                  key={index}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-2"
                >
                  <figure className="bg-white w-full h-16 p-2 flex items-center justify-center rounded-md shadow-sm">
                    <Image
                      src={item.img}
                      alt="partner-image"
                      width={500}
                      height={200}
                      className="max-h-10 w-auto max-w-[85%] object-contain object-center"
                    />
                  </figure>
                </Link>
              ))}
            </Slider>
          </div>
        </div>

        {/* footer content */}
        <div className="w-11/12 4xl:w-10/12 mx-auto grid lg:grid-cols-6 py-3  place-items-start gap-8 z-0 relative">
          <div className="flex w-full flex-col gap-8 col-span-2">
            <Image
              alt="infinity-logo"
              src="/logo/infinity-logo.png"
              width={128}
              height={32}
            />
            <div className="flex flex-col gap-3 relative">
              <div className="flex flex-col gap-1">
                <span className="font-medium text-zinc-100">Address</span>
                <p className="text-zinc-300 text-sm">
                  Dhumbarahi, Kathmandu, Nepal <br /> +977-9856008848
                </p>
              </div>
              <div className="flex flex-col gap-1">
                <span className="font-medium text-zinc-100">Email</span>
                <p className="text-zinc-300 text-sm">
                  <span className="font-medium">For inquiries:</span>{" "}
                  info@infinityadventurenepal.com <br />
                </p>
              </div>
              <div className="flex my-2 gap-4 items-center text-2xl">
                <Link
                  href="https://www.facebook.com/infinityexped"
                  target="_blank"
                >
                  <Icon icon="logos:facebook" />
                </Link>
                <Link href="https://wa.me/9856008848" target="_blank">
                  <Icon icon="logos:whatsapp-icon" />
                </Link>
                <Link
                  href=" https://www.instagram.com/infinityadventurenepal/
"
                  target="_blank"
                >
                  <Icon icon="skill-icons:instagram" />
                </Link>
                <Link
                  href="https://www.youtube.com/@infinityadventurenepal"
                  target="_blank"
                >
                  <Icon icon="logos:youtube-icon" width={30} />
                </Link>
                <Link
                  href="https://www.linkedin.com/company/infinityadventure/"
                  target="_blank"
                >
                  <Icon icon="devicon:linkedin" />
                </Link>
              </div>
            </div>

            <div className="flex gap-8 ">
              {/* associated section */}
              <div className="text-white">
                <h2 className="text-center">Associated With</h2>
                <div className="flex items-center">
                  {associate.map((item, index) => (
                    <div key={index} className=" ">
                      <Image
                        src={item.img}
                        alt="expert-image"
                        width={1000}
                        height={1000}
                        className="w-20 h-20 my-2  object-contain mx-auto object-center"
                      />
                      <p className="sm:text-xs text-[8px] md:w-[80%]  text-center mx-auto">
                        {item.title}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="text-white">
                <h2 className="whitespace-nowrap text-center">
                  Professional Affiliation
                </h2>
                <div className="flex items-center gap-2 bg-white my-2 rounded-full w-fit mx-auto">
                  <Image
                    src="/logo/certified.png"
                    alt="expert-image"
                    width={1000}
                    height={1000}
                    className="w-20 h-20 rounded-full object-cover object-center"
                  />
                </div>
                <p className="sm:text-xs text-[8px] md:w-[80%] text-center mx-auto">
                  International Federation of Mountain Guides Associations
                </p>
              </div>
            </div>
          </div>

          <div className="w-full flex flex-col gap-5 justify-center items-start">
            <h1 className="font-semibold text-lg text-zinc-50">Company</h1>
            <div className="flex flex-col gap-2 md:text-base  text-sm">
              {CompanyLinks.map((link, index) => (
                <Link
                  key={index}
                  href={link.href}
                  className="text-zinc-400 hover:text-orange-500 hover:ml-2 duration-300"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h1 className="font-semibold md:text-lg text-md text-zinc-50">
              Mountaineering
            </h1>
            <div className="mt-5 flex flex-col gap-2 md:text-base text-sm">
              {expeditions
                .filter((item, index) => {
                  return item.collections.slug === "mountaineering";
                })
                .slice(0, 10)
                .map((item) => (
                  <div key={item._id} className="">
                    <Link href={`/package_detail/${item.slug} `}>
                      <h2 className="text-zinc-400 md:text-base text-sm hover:text-orange-500 hover:ml-2 duration-300">
                        {item.name}
                      </h2>
                    </Link>
                  </div>
                ))}
            </div>
          </div>

          <div>
            <h1 className="font-semibold text-lg text-zinc-50">Trekking</h1>
            <div className="mt-5 flex flex-col gap-2 md:text-base text-sm">
              {expeditions
                .filter((item, index) => {
                  return item.collections.slug === "trekking";
                })
                .slice(0, 10)
                .map((item, index) => (
                  <div key={index} className="">
                    <Link href={`/package_detail/${item.slug} `}>
                      <h2 className="text-zinc-400 whitespace-nowrap hover:text-orange-500 hover:ml-2 duration-300">
                        {item.name}
                      </h2>
                    </Link>
                  </div>
                ))}
            </div>
          </div>

          <div className="w-full flex flex-col gap-5 justify-center items-start">
            <h1 className="font-semibold text-lg text-zinc-50">Services</h1>
            <div className="flex flex-col gap-2 md:text-base text-sm">
              {collections
                ?.filter((item) => item.collections.slug === "services")
                .map((item, index) => (
                  <Link
                    key={index}
                    href={`/other_activities/${item.slug}`}
                    className="text-left hover:text-orange-500 text-zinc-300 text-[15px] cursor-pointer"
                  >
                    {item.name}
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </div>
      <Image
        src="/linemountain.svg"
        alt="logo"
        width={1000}
        height={1000}
        className="w-11/12 mx-auto lg:-mt-32 3xl:-mt-40 -mt-10 md:-mt-24"
      />
      <div className="w-full relative border-zinc-800 py-2 text-center">
        <div className="justify-between w-11/12 mx-auto items-center flex flex-col md:flex-row gap-2">
          <span className=" text-[12px] text-zinc-300">
            ©{currentYear} Infinity Adventure Nepal Pvt. Ltd. | All Rights
            Reserved
          </span>
          <div className="flex justify-center items-center gap-2">
            <span className="text-zinc-300 text-[12px]">
              Designed and Developed by{" "}
            </span>
            <div className="relative w-12 h-10">
              <Link href="https://webxnepal.com/" target="_blank">
                <Image fill src="https://webxnepal.com/logo/logo.svg" alt="" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
